import {createAction} from '@reduxjs/toolkit';

export const changeMapView = createAction('CHANGE_MAP_VIEW');

export const resetMap = createAction('RESET_MAP');

export const pinMap = createAction('PIN_MAP');

export const clearMapPin = createAction('CLEAR_PIN_MAP');

export const fitExtent = createAction('FIT_MAP_EXTENT');

export const setDrawTool = createAction('SET_DRAW_TOOL');

export const setOverlayOn = createAction('SET_OVERLAY_ON');

export const setUserOverlayUrl = createAction('SET_USER_OVERLAY_URL');

export const setMeasureMode = createAction('SET_MEASURE_MODE');
